import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { selectQueueState } from '../../../../app/utils/reselect';
import { actions as conversationActions } from '../../../conversation/actions/conversation';
import { getAllQueues } from '../../../settings/actions/queues';
import { followUpModalActions } from '../actions/followUpModal';
import FollowUpModal from '../components/FollowUpModal';

const mapStateToProps = (state: any) => {
  return {
    ui: state.followUpModal.ui,
    timestamp: state.followUpModal.timestamp,
    csid: state.followUpModal.csid,
    conversationQueueId: state.followUpModal.conversationQueueId,
    queuesState: selectQueueState(state),
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    modalClose: () => dispatch(followUpModalActions.followUpModalClose()),
    setConversationToPending: bindActionToPromise(
      dispatch,
      conversationActions.conversationToPending,
    ),
    getAllQueues: () => dispatch(getAllQueues()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowUpModal);
